<template>
  <!-- 区域管理 -->
  <div class="page_box">
    <div class="page_option_box">
      <el-page-header
        @back="$Common.pageJump('/safety_inspection', 3)"
        content="监控区域"
      >
      </el-page-header>
      <el-button
        type="primary"
        size="mini"
        plain
        icon="el-icon-circle-plus-outline"
        @click="addInfo"
        :disabled="editOption"
        >新增监控区域</el-button
      >
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column type="index" label="序号" width="70" align="center">
          </el-table-column>
          <el-table-column prop="areaName" label="区域名称" align="center">
            <template slot-scope="rowData">
              <span v-if="!rowData.row.isEdit">{{ rowData.row.areaName }}</span>
              <el-input
                v-else
                style="width:95%"
                v-model.trim="rowData.row.areaName"
                placeholder="请输入区域名称"
                clearable
                size="small"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="rowData">
              <div v-if="!rowData.row.isEdit">
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  :disabled="editOption"
                  @click="openEditBox(rowData.row)"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="delMonitoringArea(rowData.row)"
                        :underline="false"
                        >删除</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="toMonitorList(rowData.row.id)"
                        :underline="false"
                        >区域下的监控</el-link
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-else>
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="monitoringOperation(rowData.row)"
                  >保存</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="cencelOption(rowData.row)"
                  >取消</el-link
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      tableData: [],
      requestData: {
        schoolId: this.$store.state.schoolId
      },
      editOption: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    toMonitorList(id) {
      sessionStorage.setItem("selectedMonitorRegion", id);
      if (sessionStorage.getItem("selectedMonitorRegion") == id) {
        this.$Common.pageJump("/monitor_list");
      }
    },
    addInfo() {
      let obj = {
        id: "",
        areaName: "",
        isEdit: true
      };
      this.tableData.push(obj);
      this.editOption = true;
    },
    // 打开编辑框
    openEditBox(data) {
      data.isEdit = true;
      this.editOption = true;
    },
    // 删除监控区域
    async delMonitoringArea(thisData) {
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var paramData = {
            id: thisData.id
          };
          const loading = this.$loading({
            lock: true,
            text: "数据删除中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let res = await this.$Http.delMonitoringArea(paramData);
          if (res.code == 200) {
            loading.close();
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getMonitoringArea();
          } else if (res.code == 101) {
          } else {
            loading.close();
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 监控区域操作  添加 / 编辑
    async monitoringOperation(info) {
      if (!info.areaName) {
        this.$message({
          type: "warning",
          message: "请输入区域名称！"
        });
        return;
      }
      let obj = {
        id: info.id || "",
        schoolId: this.$store.state.schoolId,
        areaName: info.areaName
      };
      let res = await this.$Http.monitoringOperation(obj, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getMonitoringArea();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    cencelOption() {
      this.getMonitoringArea();
    },
    // 获取监控区域
    async getMonitoringArea() {
      var newParamData = this.requestData;
      let res = await this.$Http.getMonitoringArea(newParamData);
      this.editOption = false;
      if (res.code == 200) {
        let data = res.data || [];
        this.tableData = data.map((item, index) => {
          item.isEdit = false;
          return item;
        });
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getMonitoringArea();
  }
};
</script>
<style scoped></style>
